module.exports = {
      id: "search-usage",
      viewBox: "0 0 20 20.051",
      url: "/" + "sprite-72169aba3aaebb7b19ede7951c92022d.svg#search",
      toString: function () {
        return this.url;
      }
    }